import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default function () {
	gsap.registerPlugin(ScrollTrigger);

	gsap.from(".anima-home > *", {
		y: 50,
		opacity: 0,
		duration: 0.8,
		stagger: 0.2
	});
}